/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordListItemFieldComponent } from '../../admin/form/form-record/fields/list-item/form-record-list-item-field.component';
/* eslint-enable */

export class FormRecordListItemFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordListItemFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
